export default function languageSelect() {
    const select = document.querySelector("[data-language-select]");

    if (!select) {
        return;
    }

    const routeLanguage = window.location.pathname.split("/")[1].toLowerCase();
    const documentLanguage = document.documentElement.lang.toLowerCase();
    const currentLanguage = routeLanguage || documentLanguage;
    const selectedOption = Array.from(select.options).find((option) => {
        const locale = option.dataset.locale.toLowerCase();
        return locale === currentLanguage || locale.split("-")[0] === currentLanguage;
    });

    if (selectedOption) {
        select.value = selectedOption.value;
    }

    select.addEventListener("change", () => {
        window.location.assign(select.value);
    });
}
